import React from 'react';
import BlurFade from '../primitives/BlurFade';
import Pill from '../ui/Pill';
import { Section } from '../layout/Section';
import { Container } from '../layout/Container';
import { Eyebrow, Headline, Body } from '../layout/typography';
import { useLang } from '../../LangContext';
import { mediaAlt as resolveMediaAlt } from '../../lib/mediaSeo';

/**
 * SplitBlock — universal side-by-side block (Problem, Empathy, Promise).
 * side: 'left' (media left) | 'right' (media right)
 * headlineAccent: optional second line rendered in muted/leaf color
 */
export default function SplitBlock({
  id, testId, tone = 'cream', rhythm = 'grand',
  side = 'right', eyebrow, headline, headlineAccent, body, cta, mediaSrc, mediaAlt = '',
  headlineSize = 'lg',
}) {
  const { lang, overlay } = useLang();
  const resolvedMediaAlt = resolveMediaAlt(overlay, mediaSrc, lang, mediaAlt || headline || eyebrow || '');
  const mediaCol = side === 'left' ? 'lg:col-start-1 lg:col-span-6 lg:row-start-1' : 'lg:col-start-8 lg:col-span-5 lg:row-start-1';
  const textCol  = side === 'left' ? 'lg:col-start-8 lg:col-span-5 lg:row-start-1' : 'lg:col-start-1 lg:col-span-6 lg:row-start-1';
  return (
    <Section id={id} data-testid={testId} tone={tone} rhythm={rhythm}>
      <Container className="grid grid-cols-1 lg:grid-cols-12 gap-y-12 lg:gap-x-16 items-center relative z-10">
        <BlurFade className={textCol} delay={0.05}>
          {eyebrow && <Eyebrow className="mb-7">{eyebrow}</Eyebrow>}
          <Headline size={headlineSize}>
            {headline}
            {headlineAccent && (
              <>
                {' '}
                <span className="text-[#F26B1A]">{headlineAccent}</span>
              </>
            )}
          </Headline>
          {body && <Body className="mt-7 max-w-md">{body}</Body>}
          {cta && (
            <div className="mt-9">
              <Pill variant="leaf" href={cta.href} testId={cta.testId} source={cta.source}>
                {cta.label}
              </Pill>
            </div>
          )}
        </BlurFade>

        <BlurFade className={mediaCol} delay={0.15} offset={14}>
          <div className="relative rounded-[20px] overflow-hidden aspect-[4/5] depth-card bg-white">
            <img src={mediaSrc} alt={resolvedMediaAlt} className="absolute inset-0 w-full h-full object-cover" />
          </div>
        </BlurFade>
      </Container>
    </Section>
  );
}
